var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalDisbursed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5532 27.5585L10.3139 26.9L9.61333 26.9L3.11111 26.9C1.94891 26.9 1 25.9493 1 24.8L1 3.1C1 1.95065 1.94891 0.999998 3.11111 0.999998L24.8889 1C26.0511 1 27 1.95065 27 3.1L27 24.8C27 25.9493 26.0511 26.9 24.8889 26.9L18.3867 26.9L17.6861 26.9L17.4468 27.5585C16.9292 28.983 15.5788 30 14 30C12.4212 30 11.0708 28.983 10.5532 27.5585ZM14.7058 3.94163L14 3.23831L13.2942 3.94163L5.51638 11.6916L3.80189 13.4L6.22222 13.4L9.88889 13.4L9.88889 18.6L9.88889 19.6L10.8889 19.6L17.1111 19.6L18.1111 19.6L18.1111 18.6L18.1111 13.4L21.7778 13.4L24.1981 13.4L22.4836 11.6916L14.7058 3.94163ZM11.4444 26.35C11.4444 27.7582 12.5955 28.9 14 28.9C15.4045 28.9 16.5556 27.7582 16.5556 26.35C16.5556 24.9418 15.4045 23.8 14 23.8C12.5955 23.8 11.4444 24.9418 11.4444 26.35Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDisbursed);
export default __webpack_public_path__ + "static/media/Total Disbursed.2f16a2b64284bda37e1a01452f3b609b.svg";
export { ForwardRef as ReactComponent };